import 'babel-polyfill';
import 'bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { Router, HashRouter } from 'react-router-dom';

import routes from './routes';
import reducers from './services';
import { authenticate } from './services/authentication';
import prsLogo from './images/prs-for-music-bw.svg';

// Get the PRSfM styles
import './app.scss';

// Preload image
const img = new Image();
img.src = prsLogo;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

store.dispatch(authenticate());

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <HashRouter>{routes}</HashRouter>
    </Router>
  </Provider>,
  document.getElementById('pwa-app'),
);
